import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AutoLoginComponent } from './auto-login.component';



@NgModule({
  declarations: [AutoLoginComponent],
  imports: [
    CommonModule
  ],
  exports: [AutoLoginComponent]
})
export class AutoLoginModule { }
